module.exports = __webpack_public_path__ + "static/img/mb-13.5f073cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w10/mb-13.jpg
// module id = Uw0X
// module chunks = 1